// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from 'firebase/storage';
import { getDatabase } from "firebase/database"; // ✅ Add this


import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  runTransaction,
  addDoc,
  setLogLevel,
  onSnapshot,
  Timestamp,
  serverTimestamp
} from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

// ✅ Use actual bucket name
const firebaseConfig = {
  apiKey: "AIzaSyB7WARmJTlzMP2i24ewjCoi_5ZisYPQr6M",
  authDomain: "yme-dp-manager.firebaseapp.com",
  projectId: "yme-dp-manager",
  storageBucket: "yme-dp-manager.firebasestorage.app", // ✅ FIXED
  messagingSenderId: "476093272806",
  appId: "1:476093272806:web:8ca1e969a0abb26bdfa127",
  databaseURL: "https://yme-dp-manager-default-rtdb.europe-west1.firebasedatabase.app"

};

const app = initializeApp(firebaseConfig);

// ✅ Ensure Firestore and Auth are initialized
const functions = getFunctions(app, "us-central1");
const db = getFirestore(app);
const auth = getAuth(app);

// NOTE: Emulator disabled - using production functions to avoid auth issues
// Connect to emulator in development
// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
//   console.log('🔧 Using Firebase Functions Emulator');
// }

// Ensure session persists across reloads in dev and prod
setPersistence(auth, browserLocalPersistence);
const messaging = getMessaging(app);

// ✅ Explicitly bind to real bucket
const storage = getStorage(app, "gs://yme-dp-manager.firebasestorage.app");
const realtimeDb = getDatabase(app, "https://yme-dp-manager-default-rtdb.europe-west1.firebasedatabase.app"); // ✅ Explicit region

setLogLevel("error");

export {
  app,
  functions,
  db,
  auth,
  messaging,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  runTransaction,
  addDoc,
  onSnapshot,
  serverTimestamp,
  storage,
  Timestamp,
  realtimeDb // ✅ Add this line
};
